import { firebaseAuth } from '@/config/firebaseClientConfig'

const getFirebaseToken = async (): Promise<string> => {
    const token = await firebaseAuth.currentUser?.getIdToken()
    return token ?? ''
}

export default getFirebaseToken
